const bubbles = [
    {
        title: 'Рядом с домом',
        description: 'Подберем удобную работу<br />в городах или районах',
    },
    {
        title: 'Проверенные заказчики',
        description: 'Все партнеры на платформе<br />проверенные компании',
    },
    {
        title: 'Гибкие слоты оказания услуг',
        description: 'Можно выходить на полный<br />день или на подработку',
    },
] as const;

export default bubbles;
